/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import styles from "./styles/RouteCard.module.scss";
import ContentContainer from "Components/Container/ContentContainer";
import { Col, Row } from "react-bootstrap";
import {
  Description,
  Input,
  LabelSubHeader,
} from "Components/CustomComponents";
import { FaChevronDown } from "react-icons/fa6";
import {
  Control,
  Controller,
  FieldValues,
  UseFormRegister,
  UseFormSetValue,
} from "react-hook-form";
import MapContainer from "Components/Map/MapContainer";
import { DraggableAttributes } from "@dnd-kit/core";

export interface RouteStop {
  id?: string;
  slug?: string;
  customer_name: string;
  customer_location: string;
  latitude: string;
  longitude: string;
  phone_number: string;
  customer_notes: string;
  is_one_time_stop?: number;
}

interface ComponentProps {
  isAccordian?: boolean;
  oneTime?: boolean;
  count?: number;
  index: number;
  register: UseFormRegister<FieldValues>;
  control: Control<FieldValues>;
  remove: (index: number) => void;
  stopData: RouteStop;
  setValue: UseFormSetValue<FieldValues>;
}

const RouteCard: React.FC<ComponentProps> = ({
  isAccordian = false,
  index,
  register,
  control,
  remove,
  stopData,
  setValue,
}) => {
  const [isOpened, setIsOpened] = useState<boolean>(!isAccordian);
  const [isMapOpen, setIsMapOpen] = useState<boolean>(false);
  const [selectedLocation, setSelectedLocation] = useState({
    lat: 24.870912,
    lng: 67.059712,
    address: "",
  });
  // console.log(stopData);

  useEffect(() => {
    setValue(
      `route_stops.${index}.customer_location`,
      selectedLocation.address
    );
    setValue(`route_stops.${index}.latitude`, selectedLocation.lat);
    setValue(`route_stops.${index}.longitude`, selectedLocation.lng);
  }, [selectedLocation, setValue, index]);

  useEffect(() => {
    setSelectedLocation({
      address: stopData.customer_location,
      lat: stopData.latitude as unknown as number,
      lng: stopData.longitude as unknown as number,
    });
  }, [stopData]);

  return (
    <div className={styles.RouteCard}>
      <ContentContainer
        bg="#F5F5F5"
        hasBoxShadow={false}
        classes={`${isAccordian ? styles.accordianContainer : ""} ${isOpened ? styles.active : ""
          }`}
      >
        <div
          className="d-flex flex-row align-items-center justify-content-between"
          onClick={!isAccordian ? () => { } : () => setIsOpened((prev) => !prev)}
        >
          {isAccordian ? (
            <Description
              text={
                <>
                  Stop {index + 1}
                  {stopData.is_one_time_stop && (
                    <span className="fw-lighter ms-1">( One Time )</span>
                  )}
                </>
              }
              classes={isOpened ? "highlighted fw-bold" : ""}
            />
          ) : (
            <LabelSubHeader
              text={
                <>
                  Stop {index + 1}
                  {stopData.is_one_time_stop && (
                    <span className="fw-lighter ms-1">( One Time )</span>
                  )}
                </>
              }
            />
          )}
          {!isAccordian ? null : (
            <div className={styles.accordianArrow}>
              <FaChevronDown
                size={20}
              // onClick={() => remove(index)}
              />
            </div>
          )}
        </div>
        <div
          className={`${isAccordian ? styles.accordianContentContainer : ""} ${isOpened ? styles.active : ""
            }`}
        >
          <Row className="mt-2">
            <Col lg={4}>
              <Controller
                name={`route_stops.${index}.customer_name`}
                control={control}
                // rules={{
                //   required: "Customer name is required.",
                // }}
                render={({ field: { onChange, value } }) => (
                  <Input
                    placeholder="Customer Name"
                    value={value}
                    onChange={onChange}
                  />
                )}
              />
            </Col>
            <Col lg={4}>
              <Controller
                name={`route_stops.${index}.customer_location`}
                control={control}
                render={({ field: { onChange, value } }) => (
                  <Input
                    placeholder="Customer Address/Location"
                    value={value || selectedLocation.address}
                    onChange={() => {
                      onChange(selectedLocation.address);
                    }}
                    onClick={() => setIsMapOpen(true)} // Open Map Modal on click
                    readOnly={true}
                  />
                )}
              />
            </Col>

            <Controller
              name={`route_stops.${index}.latitude`}
              control={control}
              render={({ field: { onChange, value } }) => (
                <Input
                  type="hidden"
                  value={selectedLocation.lat || value}
                  //   onChange={onChange}
                  onChange={() => onChange(selectedLocation.lat)}
                />
              )}
            />

            <Controller
              name={`route_stops.${index}.longitude`}
              control={control}
              render={({ field: { onChange, value } }) => (
                <Input
                  type="hidden"
                  value={selectedLocation.lng || value}
                  //   onChange={onChange}
                  onChange={() => onChange(selectedLocation.lng)}
                />
              )}
            />

            <Col lg={4}>
              <Controller
                name={`route_stops.${index}.phone_number`}
                control={control}
                render={({ field: { onChange, value } }) => (
                  <Input
                    type="tel"
                    placeholder="Phone Number"
                    value={value}
                    onChange={onChange}
                  />
                )}
              />
            </Col>
            <Col md={12}>
              <Controller
                name={`route_stops.${index}.customer_notes`}
                control={control}
                render={({ field: { onChange, value } }) => (
                  <Input
                    placeholder="Add Note About Customer"
                    as="textarea"
                    rows={4}
                    value={value}
                    onChange={onChange}
                  />
                )}
              />
            </Col>
          </Row>
          {isMapOpen && (
            <MapContainer
              setClose={() => setIsMapOpen(false)}
              searchBar={false}
              isEdit={true}
              location={{
                lat: selectedLocation.lat,
                lng: selectedLocation.lng,
              }}
              setLatLng={(latlng) =>
                setSelectedLocation((prev) => {
                  return { ...prev, lat: latlng.lat, lng: latlng.lng };
                })
              }
              address={selectedLocation.address}
              setAddress={(address) =>
                setSelectedLocation((prev) => {
                  return { ...prev, address: address };
                })
              }
            />
          )}
        </div>
      </ContentContainer>
    </div>
  );
};

export default RouteCard;
